(function ($) {
  "use strict";

  $("#heroNav").on("click", "a", function (e) {
    e.preventDefault();

    const target = this.hash;

    // Hero
    $(".hero__tab").removeClass("active");
    $(`${target}-hero`).addClass("active");

    // Hero Content
    $(".hero-content__tab").removeClass("active");
    $(`${target}-content`).addClass("active");

    // Nav Link
    $(".hero-nav__link").removeClass("active");
    $(this).addClass("active");
  });
})(jQuery);
